import React from "react";

interface FormSectionProps {
  title?: string;

  description?: string;

  children: React.ReactNode;

  columns?: 1 | 2 | 3;

  className?: string;
}

export default function FormSection({
  title,
  description,
  children,
  columns = 2,
  className = "",
}: FormSectionProps) {
  const gridClass = {
    1: "grid-cols-1",
    2: "grid-cols-1 md:grid-cols-2",
    3: "grid-cols-1 md:grid-cols-2 xl:grid-cols-3",
  }[columns];

  return (
    <section className={className}>
      {(title || description) && (
        <div className="mb-6">
          {title && (
            <h3 className="text-lg font-semibold text-slate-900">
              {title}
            </h3>
          )}

          {description && (
            <p className="mt-1 text-sm text-slate-500">
              {description}
            </p>
          )}
        </div>
      )}

      <div className={`grid gap-6 ${gridClass}`}>
        {children}
      </div>
    </section>
  );
}